import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import DataSource from 'devextreme/data/data_source';

@Component({
    selector: 'app-activity-group-field',
    templateUrl: './activity-group-field.component.html',
    styleUrls: ['./activity-group-field.component.scss'],
    standalone: false
})
export class ActivityGroupFieldComponent implements OnInit {

	@Input() public activityGroupsTableData: any[];

	@Input() public activityGroupsSelectionData: DataSource;

	@Output() public valueChange: EventEmitter<any> = new EventEmitter<boolean>();

	private _value: any = false;
	@Input()
	public set value(value: any) {
		this._value = value;

		this.valueChange.emit(this._value);
	}
	public get value(): any {
		return this._value;
	}

	constructor() { }

	ngOnInit() {
		
	}
}
